import React from "react";
import {findDOMNode} from "react-dom";

import PopoverAddColumn from "../../../../../../gd-modules/common/add-column-new/popover/popover";
import Popover from "../../../../../../gd-components/gd-popover/popover-v2";
import PopoverPosition from "../../../../../../gd-components/gd-popover/popover-position";
import FieldSelectField from "../../select-field";
import convertFieldsStructureToConfig, {
    FieldSelectorConfig
} from "../../../../../../gd-modules/common/add-column-new/convert-fields-structure";

// const debug = "FieldSelectField_Popover"
const debug = false

export default function FieldSelectField_Popover(props:any) {

    // Etot popover rabotaet v dvux vaiantax. Ono vsegda mojet viberat odin field. No selected item mojet bit odin ili neskolko.
    // Vse zavisit ot togo kakoy props ispolzuem. "colums" ili "selectedFieldIds"
    // PopoverAddColumn ispolzuetsya s "columns" v drugix mestax. Nado bit akkuratno!!!

    const value = props.field.getViewValue(props.model)
    const selectedFieldIds = props.field.fieldParams.selectedFieldIds ? props.field.fieldParams.selectedFieldIds : [value]
    const field : FieldSelectField = props.field
    const config: FieldSelectorConfig = convertFieldsStructureToConfig(field.fieldsStructure)

    const isAddVisible = _.get(props.field.fieldParams, "canAddNewField", false)
    const onAddField = _.get(props.field.fieldParams, "onAddField", ()=>{})

    const onClickOutside = (e: React.MouseEvent) => {
        debug && console.log(debug, 'onClickOutside')

        props.parent.hidePopover()
    }

    const onSelect = (value: ID | null) => {
        debug && console.log(debug, 'onSelect', props.field.fieldParams)

        if (!props.field.fieldParams.keepPopoverOpenOnSelect) {
            props.parent.hidePopover()
        }

        // Eto ubivaet toggle field. Eto nado zdelat posle
        // if (selectedFieldIds.includes(value)) return

        props.parent.onValueChange(value, false)
    }

    const columns = [{
        fieldId: value
    }]

    let noValueOption
    if (field.noValueOption) {
        noValueOption = {
            icon    : field.noValueOptionIcon,
            label   : field.noValueOptionLabel
        }
    }

    const popoverPosition = new PopoverPosition({
        attachment          : props.options?.attachment,
        targetAttachment    : props.options?.targetAttachment,
    })

    return (
        <Popover
            popoverClass        = "gd-popover-add-column-new h-350"
            position            = {popoverPosition}
            onClickOutside      = {onClickOutside}
            getTargetFunc       = {()=>findDOMNode(props.parent)}
        >
            <PopoverAddColumn
                config              = {config}
                fields              = {field.fields.models}
                selectedFieldIds    = {selectedFieldIds}
                columns             = {columns}
                mandatoryColumnsIds = {[]}
                noValueOption       = {noValueOption}
                isAddVisible        = {isAddVisible}
                hidePopover         = {props.parent.hidePopover}
                onToggleColumn      = {onSelect}
                // onAddCustomField    = {this.onAddCustomField}
                onNewCustomField    = {onAddField}
            />
        </Popover>
    )
}
